import React from "react";

export default function TeamMembers({member}) {

  const {name, avatar} = member || {};
  return (
      <div className="mt-3 space-y-4">
        <div className="checkbox-container">
          <img src={avatar} alt={name} className="team-avater" />
          <p className="label">{name}</p>
        </div>
      </div>
  );
}
